import React from "react";
import { Box, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { colors } from "../utils/theme";

const steps = [
  { label: "Delivery", route: "/delivery-location" },
  { label: "Summary", route: "/order-summary" },
  { label: "Payment", route: "/payment" },
  { label: "Success", route: "/order-success" },
];

const CheckoutBreadcrumbs = ({ active }) => {
  const navigate = useNavigate();

  const handleClick = (index) => {
    if (active === 3) return;
    if (index <= active) {
      navigate(steps[index].route);
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mt: "44px",
        mb: 3,
        px: 2,
        py: { xs: 1, sm: 1.5 },
        bgcolor: colors.surfaceContainerLowest,
        borderRadius: { xs: 0, sm: 1 },
        boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
        border: { xs: "none", sm: "1px solid" },
        borderColor: { xs: "transparent", sm: colors.outlineVariant },
        maxWidth: 700,
        mx: { xs: -1.5, sm: "auto" },
        minHeight: 40, 
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      {steps.map((step, i) => {
        const isCompleted = i < active;
        const isSuccessDone = step.label === "Success" && active === 3;
        const isActive = i === active && !isSuccessDone;

        const color =
          isCompleted || isSuccessDone
            ? colors.successGreen
            : isActive
            ? colors.secondaryContainer
            : colors.textMuted;

        return (
          <Box
            key={i}
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              minWidth: { xs: 72, sm: 90 },
              cursor: i <= active ? "pointer" : "not-allowed",
            }}
            onClick={() => handleClick(i)}
          >
            <Box
              sx={{
                width: { xs: 24, sm: 28 },
                height: { xs: 24, sm: 28 },
                borderRadius: "50%",
                bgcolor: color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: { xs: 12, sm: 14 },
                fontWeight: 700,
                flexShrink: 0,
              }}
            >
              {isCompleted || isSuccessDone ? (
                <CheckCircle sx={{ fontSize: { xs: 16, sm: 18 } }} />
              ) : (
                i + 1
              )}
            </Box>

            <Typography
              sx={{
                ml: { xs: 0.5, sm: 1 },
                fontSize: { xs: 11, sm: 13 },
                fontWeight: isActive ? 700 : 500,
                color,
                whiteSpace: "nowrap",
              }}
            >
              {step.label}
            </Typography>

            {i !== steps.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  height: 2,
                  mx: { xs: 0.5, sm: 1 },
                  bgcolor: i < active ? "#2e7d32" : "#e0e0e0",
                }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default CheckoutBreadcrumbs;